// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { ExecutedMint } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useExecutedMints2Step: () => UseQueryResult<
  TemplateContract<ExecutedMint>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  return useQueryWithOffset({
    queryKey: ['queryExecutedMintsTwoStep'],
    queryFn: async (_, offset) => {
      return ledgerApi.queryExecutedMintsTwoStep(offset);
    },
  });
};
